import { HelpCircleFilled, BuildingRestaurant, SettingsToggle } from '@creditornot/cb-icons';
import React, { ReactNode } from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

type VenueMerchantData = {
  id: string;
  name: string;
};

type VenueBrandData = {
  enterpriseId: string;
  id: string;
  name: string;
};

type Action = {
  icon: ReactNode;
  name: ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

type ActionGroup = {
  title: string;
  actions: Action[];
};

const OpsToolsTag = () => <SettingsToggle />;

const MerchantAdminTag = () => <BuildingRestaurant />;

export const buildVenueDropdownItems = (
  venue: Venue,
  venueMerchantData?: VenueMerchantData,
  venueBrandData?: VenueBrandData,
): ActionGroup[] => {
  const merchantAdminBaseUrl =
    process.env.APP_ENV === 'production'
      ? 'https://merchant.wolt.com'
      : 'https://merchant-admin.development.dev.woltapi.com';

  const opsToolsBaseUrl =
    process.env.APP_ENV === 'production' ? 'https://ops.wolt.com' : 'https://ops-tools.development.dev.woltapi.com';

  const merchantInfo = venueMerchantData
    ? {
        merchantId: venueMerchantData.id,
        merchantName: venueMerchantData.name,
      }
    : undefined;

  const brandInfo = venueBrandData
    ? {
        brandId: venueBrandData.id,
        enterpriseId: venueBrandData.enterpriseId,
        brandName: venueBrandData.name,
      }
    : undefined;

  const menuItems: ActionGroup[] = [
    {
      title: `Venue - ${venue.name[0].value}`,
      actions: [
        {
          icon: <MerchantAdminTag />,
          name: 'Merchant Admin',
          onClick: () => window.open(`${merchantAdminBaseUrl}/venue/${venue.slug}/`, '_blank'),
        },
        {
          icon: <OpsToolsTag />,
          name: 'Ops Tools',
          onClick: () => window.open(`${opsToolsBaseUrl}/venues/${venue.id}/info`, '_blank'),
        },
      ],
    },
    {
      title: `Merchant - ${merchantInfo ? merchantInfo.merchantName : 'No Merchant'}`,
      actions: [
        {
          icon: merchantInfo ? <MerchantAdminTag /> : <HelpCircleFilled />,
          name: 'Merchant Admin',
          onClick: () =>
            merchantInfo
              ? window.open(`${merchantAdminBaseUrl}/merchant/${merchantInfo?.merchantId}`, '_blank')
              : undefined,
          disabled: !merchantInfo,
        },
        {
          icon: merchantInfo ? <OpsToolsTag /> : <HelpCircleFilled />,
          name: 'Ops Tools',
          onClick: () =>
            merchantInfo
              ? window.open(`${opsToolsBaseUrl}/merchants/${merchantInfo?.merchantId}/overview`, '_blank')
              : undefined,
          disabled: !merchantInfo,
        },
      ],
    },
    {
      title: `Brand - ${brandInfo ? brandInfo.brandName : 'No Brand'}`,
      actions: [
        {
          icon: brandInfo ? <MerchantAdminTag /> : <HelpCircleFilled />,
          name: 'Merchant Admin',
          onClick: () =>
            brandInfo
              ? window.open(
                  `${merchantAdminBaseUrl}/enterprise/${brandInfo.enterpriseId}/brand/${brandInfo.brandId}`,
                  '_blank',
                )
              : undefined,
          disabled: !brandInfo,
        },
        {
          icon: brandInfo ? <OpsToolsTag /> : <HelpCircleFilled />,
          name: 'Ops Tools',
          onClick: () =>
            brandInfo ? window.open(`${opsToolsBaseUrl}/enterprise/brands/${brandInfo.brandId}`, '_blank') : undefined,
          disabled: !brandInfo,
        },
      ],
    },
  ];

  return menuItems;
};
